const authPrefix = "auth/";
export const wrongPassword = `${authPrefix}wrong-password`;
export const userNotFound = `${authPrefix}user-not-found`;
export const emailAlreadyInUse = `${authPrefix}email-already-in-use`;
